module.exports = __webpack_public_path__ + "img/SV_Bios_lab-1536x864.520f729e.jpg";